import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ButtonZegel from "../Buttons/ButtonZegel";
import "./styles/CardPrograma.scss";
import useAlumno from "../../hooks/useAlumno";
import { RegistrarAsignarPrograma } from "../../services/UsuarioService";
const CardProgramaExplorar = ({ programa }) => {
  const { perfil } = useAlumno();
  const [loading, setLoading] = useState(false);

  const columnas = [];
  for (let i = 0; i < programa.listaCursos.length; i += 5) {
    columnas.push(programa.listaCursos.slice(i, i + 5));
  }

  const AsignarPrograma = () => {
    setLoading(true);
    let jwt = window.localStorage.getItem("jwt");

    let idPrograma = programa.idPrograma;
    let idUsuario = perfil.idUsuario;

    let jsonPrograma = JSON.stringify({ idUsuario, idPrograma }, null, 2);
    RegistrarAsignarPrograma({ jsonPrograma, jwt })
      .then((data) => {
        setLoading(false);
        window.location.reload(false);
      })
      .catch((errors) => {
        setLoading(false);
        alert("ocurrió un error: " + errors.message);
      });
  };

  return (
    <div className="card-programa">
      {/* <div className="card-programa-header">
        <img
          src={programa.imagenProducto}
          className="c-user-course-card__banner"
        />
        <h2 className="mb-0">{programa.nombre}</h2>
      </div> */}
      <div className="c-program-card__discount" data-v-48f3e599="">
        25%<span data-v-48f3e599=""> dto.</span>
      </div>
      <a
        href={
          "https://zegelvirtual.com/programas-virtuales/" + programa.urlRetail
        }
        target="_blank"
        className="c-program-card__banner"
        data-v-48f3e599=""
      >
        <img src={programa.imagenProducto} data-v-48f3e599="" />
        <h2 className="title" data-v-48f3e599="">
          {programa.nombre}
        </h2>
      </a>
      <div className="c-program-card__content" data-v-48f3e599="">
        <div className="info-adicional flex align-items-center">
          <div className="flex align-items-center gap-1">
            <i className="pi pi-calendar" style={{ fontSize: "11px" }}></i>
            <p>{programa.duracion + " meses"}</p>
          </div>
          {/* <div className="flex align-items-center gap-1">
            <i className="pi pi-star" style={{ fontSize: "11px" }}></i>

            <p>0.0</p>
          </div> */}
          <div className="flex align-items-center gap-2 h-1rem">
            <p style={{ fontSize: 10 }}>
              <strike>
                S/ {parseFloat(programa.precio).toFixed(2) * 1.25}
              </strike>
            </p>
            {programa.precio && (
              <p style={{ fontSize: 12, fontWeight: "bold" }}>
                S/
                {parseFloat(programa.precio).toFixed(2)}
              </p>
            )}
          </div>
        </div>
        <p
          className="description"
          data-v-48f3e599=""
          // style={{ minHeight: 100, marginBottom: 0, paddingBottom: 20 }}
        >
          {programa.descripcion}
        </p>
        <span
          className="subtitle font-bold"
          data-v-48f3e599=""
          style={{ fontSize: 12 }}
        >
          Plan de estudio
        </span>
        <div className="programaCard-content" style={{ minHeight: 100 }}>
          <div
            data-v-48f3e599=""
            className="sylabus"
            style={{ minHeight: 160 }}
          >
            <div className="sylabus-desktop">
              {columnas.map((columna, index) => (
                <ul key={index}>
                  {columna.map((elemento, elementoIndex) => (
                    <li key={elementoIndex}>{elemento.curso.nombre}</li>
                  ))}
                </ul>
              ))}
            </div>

            <div className="sylabus-mobile">
              {
                <ul>
                  {programa.listaCursos.map((elemento, elementoIndex) => (
                    <li key={elementoIndex}>{elemento.curso.nombre}</li>
                  ))}
                </ul>
              }
            </div>
          </div>
          <div className="flex align-items-end pb-2">
            <div style={{ width: "100%" }}>
              <Link
                to={
                  "https://zegelvirtual.com/programas-virtuales/" +
                  programa.urlRetail
                }
                target="_blank"
                style={{ width: "100%" }}
              >
                <ButtonZegel
                  label="Conoce más del programa"
                  color="secondary"
                ></ButtonZegel>
              </Link>
              {perfil && perfil.membresia === true && (
                <div className="mt-2">
                  <ButtonZegel
                    label="Activar programa"
                    color="terceary"
                    onClick={() => AsignarPrograma()}
                    loading={loading}
                  ></ButtonZegel>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardProgramaExplorar;
